// 上周送礼前三国家
import React from 'react'
import './index.less'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    const { list, lang, language } = this.props
    return (
      <div className='gift-wrap'>
        <div className='hd'>
          <h2>{lang.event_gift}</h2>
        </div>
        <div className='bd'>
          {/* 背景图层 */}
          <div className="bd-bg">
            <div className="gift-bg">
            </div>
            <div className="bd-bg-list">
              <div className="top">
                <img src="/img/activity/national-star/img_box_bg_frame_top@2x.png" />
              </div>
              <div className="min">
                <img src="/img/activity/national-star/img_box_bg_frame_mid@2x.png" />
              </div>
              <div className="bottombottom">
                <img src="/img/activity/national-star/img_box_bg_frame_bot@2x.png" />
              </div>
            </div>
          </div>
          {/* 背景图层 end */}
          <div className="gift-contant">
            <h2 className='gift-title'>
              {lang.event_gift_description1}
            </h2>
            <div
              className={`img-list
                ${list.length <= 3 ? 'center' : ''}
                ${isRtl(language) ? 'arlang' : ''}`
              }
            >
              {
                list &&
                list.map((item) => {
                  return (
                    <div className="img-item" key={item.image}>
                      <div className="img-wrap">
                        <img src={item.image} />
                      </div>
                      <div className="text-wrap">
                        <i className="icon-wrap">
                          <img src="/img/activity/national-star/icon_coins@2x.png" />
                        </i>
                        {item.gold}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/gift/index.js